import { useDisplayVariant } from 'modules/productDetail'
import * as React from 'react'
import styled from 'styled-components'
import config from 'config'

export default function CertifiedIcon() {
  const variant = useDisplayVariant()

  // skip if no CERTIFIED attribute is available or there is no icon for CERTIFIED
  if (
    !variant.data.attributes?.CERTIFIED ||
    !variant.data.attributes?.CERTIFIED.values[0].icon
  )
    return null

  const certifiedIcon =
    config.modules.cloudinary.endpoint +
      variant.data.attributes.CERTIFIED.values[0]?.icon || ''

  const certifiedLabel = `${variant.data.attributes.CERTIFIED.label || ''} ${
    variant.data.attributes.CERTIFIED.values[0]?.value || ''
  }`

  return (
    <Wrapper className="CertifiedIcon" data-cy-state="show-certified-icon">
      <img src={certifiedIcon} title={certifiedLabel} alt={certifiedLabel} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: end;

  > img {
    max-height: 100px;
  }
`
